export default "__VITE_ASSET__WI_vM6WQ__"